import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ProductsAndPagesSkillsRegularIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M4.667.25A4.417 4.417 0 0 0 .25 4.667l.005.214a4.42 4.42 0 0 0 2.786 3.894l.09.033L.9 11.04a2.217 2.217 0 0 0 0 3.135l2.065 2.06a.75.75 0 0 0 1.22-.24 2.917 2.917 0 1 1 3.82 3.82.75.75 0 0 0-.238 1.222l2.059 2.06.127.118a2.217 2.217 0 0 0 3.007-.118l2.232-2.23.034.092a4.418 4.418 0 0 0 8.525-1.626l-.005-.214a4.42 4.42 0 0 0-2.786-3.894l-.091-.033L23.1 12.96a2.217 2.217 0 0 0 0-3.135l-2.065-2.06a.75.75 0 0 0-1.22.24 2.917 2.917 0 1 1-3.82-3.82.75.75 0 0 0 .239-1.221L14.175.9l-.127-.118a2.217 2.217 0 0 0-3.007.117L8.808 3.132l-.033-.09A4.418 4.418 0 0 0 4.667.25zm9.817 3.083-.143.112a4.417 4.417 0 0 0 2.201 7.805l.212.023a4.418 4.418 0 0 0 3.8-1.614l.112-.144 1.375 1.371c.279.28.279.733 0 1.013l-3.238 3.237a.75.75 0 0 0 .53 1.28 2.917 2.917 0 1 1-2.916 2.917.75.75 0 0 0-1.28-.53l-3.238 3.233-.089.076a.717.717 0 0 1-.924-.076l-1.371-1.371.144-.11a4.417 4.417 0 0 0-2.201-7.805l-.212-.023a4.418 4.418 0 0 0-3.8 1.614l-.112.143-1.375-1.37a.716.716 0 0 1 0-1.013l3.238-3.237a.75.75 0 0 0-.53-1.28 2.917 2.917 0 1 1 2.916-2.917.75.75 0 0 0 1.28.53l3.238-3.237a.717.717 0 0 1 1.013 0l1.37 1.373z" />',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ProductsAndPagesSkillsRegularIcon = __decorateClass([
  customElement("elm-products-and-pages-skills-regular-icon")
], ProductsAndPagesSkillsRegularIcon);
export { ProductsAndPagesSkillsRegularIcon };
